import { Component, forwardRef, ViewChild, ElementRef, NgZone, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { ConstantService } from '../../constant/constant-service';
import { DefaultService } from '../../services/default.service';
import { StorageService } from '../../services/storage.service';

const SUPPORTED_LANGUAGES:Array<SelectItem> = [
  {label: 'English', value: 'en'},
  {label: 'Spanish', value: 'es'}
];

export const AV_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvInputDateComponent),
  multi: true
};

@Component({
  selector: 'av-input-date',
  templateUrl: './av-input-date.component.html',
  providers: [AV_INPUT_CONTROL_VALUE_ACCESSOR],
})
export class AvInputDateComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() size = '20';
  @Input() format = 'dd/mm/yy';
  @Input() disabled: Boolean = false;
  @Input() showIcon: Boolean = true;
  @Input() showTime: Boolean = false;
  @Input() showSeconds: boolean = false;
  @Input() placeholder: String;
  @Input() yearNavigator: Boolean = true;
  @Input() yearRange: String;
  @Input() monthNavigator: Boolean = true;
  @Input() defaultDate: Date = new Date();
  @Input() maxDate: Date = new Date(this.defaultDate.getFullYear() + 50,this.defaultDate.getMonth(), this.defaultDate.getDate());
  @Input() minDate: Date = new Date(this.defaultDate.getFullYear() - 50,this.defaultDate.getMonth(), this.defaultDate.getDate());
  @Input() timeOnly: boolean = false;
  @ViewChild('input') inputRef: ElementRef;
  value: any;
  calendar: any;
  es: any;
  public supportedLanguages:SelectItem[] = SUPPORTED_LANGUAGES;
  public calendar_es: any;
  public calendar_en: any;
  public lang:string;

  constructor(
    private zone: NgZone,
    private defaultService: DefaultService,
    private translate:TranslateService,
    private constantService: ConstantService,
    private storageService: StorageService
  ) {
    this.calendar_es = {
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio",
      "julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun",
      "jul","ago","sep","oct","nov","dic" ],
      dayNames: [ "domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      dayNamesMin: [ "D","L","M","X","J","V","S" ]
    };
    this.calendar_en = {
      monthNames: [ "January","February","March","April","May","June",
        "July","August","September","October","November","December" ],
      monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
      dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
      dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
      dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ]
    };
    translate.addLangs(["en", "es"]);
    translate.setDefaultLang('en');
    let browserLang = translate.getBrowserLang();
    let defaultLanguage = browserLang.match(/en|es/) ? browserLang : 'en';
    translate.use(defaultLanguage);
    this.calendar = this.storageService.getSessionStorageItem(this.constantService.SESSION_STORAGE_LANGUAJE).lang //defaultLanguage == 'es' ? this.calendar_es : this.calendar_en; //this.defaultService.calendar;
  }

  changeLanguage() {
    this.translate.use(this.lang);
    this.calendar = this.lang == 'es' ? this.calendar_es : this.calendar_en;
  }


  propagateChange = (_: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  onChange(): void {
    this.zone.run(() => {
      this.propagateChange(this.value);
    });
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
